<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb
        :bConfigList="pageConfig.detailBreadCrumb"
      ></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">补能策略</div>
      </div>
      <div
        class="detail-content-body-div flex-1 flex"
        style="justify-content: space-between;"
      >
      <div class="tariffInfo">
          <div style=" font-size: 14px;">补能时段</div>
          <el-row :gutter="1">
            <el-col
              :xs="4"
              :sm="4"
              :md="4"
              :lg="4"
              :xl="3"
              v-for="(i, n) in popup.customizeList"
            >
              <div class="tool-item">
                <div
                  @click="handletariffSelect('补能', i, n)"
                  v-if="i.section === '补能'"
                  style="background: #00c4af"
                >
                  {{ i.startTimeToEndTime }}
                </div>
                <div
                  @click="handletariffSelect('', i, n)"
                  v-else
                  style="background: #efefef;color:#999999;"
                >
                  {{ i.startTimeToEndTime }}
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="main-info">
          <div class="info-top">
            <div>补能设置</div>
            <!-- 操作按钮 -->
            <!-- <div class="btn-class">
              <el-button
                v-if="!isEdit"
                type="primary"
                size="small"
                icon="el-icon-edit"
                circle
                @click="handleEdit"
              ></el-button>
              <button
                v-if="isEdit"
                class="common-empty-button"
                @click="isEdit = false"
              >
                取 消
              </button>
              <button
                v-if="isEdit"
                class="common-bg-button"
                @click="handleSave('detailForm')"
              >
                保存
              </button>
            </div> -->
          </div>
          <div
            style="width: 100%; height: 1px; background: #ddd;margin: 24px 0;"
          ></div>

          <el-form
            :model="detailForm"
            :rules="formRules"
            ref="detailForm"
            label-width="150px"
            class="detail-form"
          >
            <div class="flex detail-form-parent-div">
              <div class="flex-1">
                <el-form-item label="本站电网最大功率：">
                  <div>
                    {{ detailForm.maxAvailablePower || "-" }}&nbsp;&nbsp;KW
                  </div>
                </el-form-item>
               
                <el-form-item
                  label="开始补能SOC："
                  prop="startEnergySoc"
                  
                >
                  <el-input
                    v-model="detailForm.startEnergySoc"
                    size="small"
                    style="width: 100%;"
                  ></el-input>
                </el-form-item>
                <!-- <el-form-item label="开始补能SOC：" v-else>
                  <div>{{ detailForm.startEnergySoc || "-" }}&nbsp;&nbsp;%</div>
                </el-form-item> -->

                <el-form-item
                  label="结束补能SOC："
                  prop="endEnergySoc"
                 
                >
                  <el-input
                    v-model="detailForm.endEnergySoc"
                    size="small"
                    style="width: 100%;"
                  ></el-input>
                </el-form-item>
                <!-- <el-form-item label="结束补能SOC：" v-else>
                  <div>{{ detailForm.endEnergySoc || "-" }}&nbsp;&nbsp;%</div>
                </el-form-item> -->

                <!-- <el-form-item
                  label="允许补能时段："
                  prop="strategys"
                  v-if="isEdit"
                >
                  <el-select
                    v-model="detailForm.strategys"
                    placeholder="请选择补能时段"
                    clearable
                    multiple
                    filterable
                    allow-create
                    default-first-option
                    style="width: 100%;"
                    @change="handleSelect"
                  >
                    <el-option
                      v-for="(item, index) in selectList"
                      :key="index"
                      :label="item.startTimeToEndTime"
                      :value="item.startTimeToEndTime"
                    ></el-option>
                  </el-select>
                  <div>
                    <span style="color: red">* </span>
                    补能时段需要前往资费中配置相对应的时段！
                  </div>
                </el-form-item>
                <el-form-item label="允许补能时段：" v-else>
                  <div>{{ detailForm.timeString || "-" }}</div>
                </el-form-item> -->
              </div>
            </div>
          </el-form>
        </div>
        
      </div>
      <div class="flex-1">
        <div class="block">
            <el-date-picker
                      size="small"
                      clearable
                      style="width:240px;"
                      :picker-options="pickerOptions"
                      
                      class="mgn-lf-10"
                      v-model="searchTime"
                      value-format="yyyy-MM"
                      type="month"
                      placeholder="选择日期"
                      @change="handleDateChange"
                    >
                    </el-date-picker>
        </div>
        <el-table
          :data="tableData"
          border
          :header-cell-style="{ background: '#e8e8e8' }"
          style="width: 100%;"
        >
          <el-table-column
            prop="createdWhen"
            label="下发时间"
            width="380"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="pileCode"
            label="设备编号"
            width="380"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="firstMsg"
            label="内容"
            width="482"
            align="center"
          >
        <template slot-scope="scope">
           <span v-html="scope.row.firstMsg"></span>
        </template>
          </el-table-column>
          <el-table-column
            prop="action"
            label="类型"
            width="250"
            align="center"
          >
          <template slot-scope="scope">
            <span style="color:rgba(0, 0, 255, 0.685);cursor: pointer;"  v-if="scope.row.flag" @click="Configuration(scope.row)">重新下发</span>
            <span style="color:gray;" v-else >重新下发</span>
          </template>
          </el-table-column>
        </el-table>
        <div class="list-pagination">
        <ZD-pagination
          :pagination="pagination"
          v-on:pageUpdate="getListData"
        ></ZD-pagination>
      </div>
      </div>

      <div class="detail-content-footer-div">
        <button class="common-bg-button" @click="submitForm('detailForm')">提 交</button>
        <button class="common-empty-button" @click="resetForm">重 置</button>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
export default {
  data() {
    return {
      tableData: [
      
      ],
      popup: {
        title: "",
        show: false,
        section: "",
        customizeList: [
          {
            startTimeToEndTime: "00:00-00:30",
            startTime: "00:00",
            endTime: "00:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "00:30-01:00",
            startTime: "00:30",
            endTime: "01:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "01:00-01:30",
            startTime: "01:00",
            endTime: "01:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "01:30-02:00",
            startTime: "01:30",
            endTime: "02:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "02:00-02:30",
            startTime: "02:00",
            endTime: "02:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "02:30-03:00",
            startTime: "02:30",
            endTime: "03:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "03:00-03:30",
            startTime: "03:00",
            endTime: "03:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "03:30-04:00",
            startTime: "03:30",
            endTime: "04:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "04:00-04:30",
            startTime: "04:00",
            endTime: "04:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "04:30-05:00",
            startTime: "04:00",
            endTime: "05:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "05:00-05:30",
            startTime: "05:00",
            endTime: "05:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "05:30-06:00",
            startTime: "05:30",
            endTime: "06:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "06:00-06:30",
            startTime: "06:00",
            endTime: "06:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "06:30-07:00",
            startTime: "06:30",
            endTime: "07:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "07:00-07:30",
            startTime: "07:00",
            endTime: "07:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "07:00-08:00",
            startTime: "07:00",
            endTime: "08:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "08:00-08:30",
            startTime: "08:00",
            endTime: "08:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "08:30-09:00",
            startTime: "08:30",
            endTime: "09:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "09:00-09:30",
            startTime: "09:00",
            endTime: "09:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "09:30-10:00",
            startTime: "09:30",
            endTime: "10:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "10:00-10:30",
            startTime: "10:00",
            endTime: "10:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "10:30-11:00",
            startTime: "10:30",
            endTime: "11:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "11:00-11:30",
            startTime: "11:00",
            endTime: "11:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "11:30-12:00",
            startTime: "11:30",
            endTime: "12:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "12:00-12:30",
            startTime: "12:00",
            endTime: "12:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "12:30-13:00",
            startTime: "12:30",
            endTime: "13:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "13:00-13:30",
            startTime: "13:00",
            endTime: "13:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "13:30-14:00",
            startTime: "13:30",
            endTime: "14:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "14:00-14:30",
            startTime: "14:00",
            endTime: "14:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "14:30-15:00",
            startTime: "14:30",
            endTime: "15:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "15:00-15:30",
            startTime: "15:00",
            endTime: "15:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "15:30-16:00",
            startTime: "15:30",
            endTime: "16:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "16:00-16:30",
            startTime: "16:00",
            endTime: "16:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "16:30-17:00",
            startTime: "16:30",
            endTime: "17:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "17:00-17:30",
            startTime: "17:00",
            endTime: "17:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "17:30-18:00",
            startTime: "17:30",
            endTime: "18:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "18:00-18:30",
            startTime: "18:00",
            endTime: "18:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "18:30-19:00",
            startTime: "18:30",
            endTime: "19:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "19:00-19:30",
            startTime: "19:00",
            endTime: "19:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "19:30-20:00",
            startTime: "19:30",
            endTime: "20:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "20:00-20:30",
            startTime: "20:00",
            endTime: "20:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "20:30-21:00",
            startTime: "20:30",
            endTime: "21:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "21:00-21:30",
            startTime: "21:00",
            endTime: "21:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "21:30-22:00",
            startTime: "21:30",
            endTime: "22:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "22:00-22:30",
            startTime: "22:00",
            endTime: "22:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "22:30-23:00",
            startTime: "22:30",
            endTime: "23:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "23:00-23:30",
            startTime: "23:00",
            endTime: "23:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "23:30-24:00",
            startTime: "23:30",
            endTime: "24:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
        ],
        timeSlotDetailList: [
          {
            startTimeToEndTime: "00:00-00:30",
            startTime: "00:00",
            endTime: "00:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "00:30-01:00",
            startTime: "00:30",
            endTime: "01:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "01:00-01:30",
            startTime: "01:00",
            endTime: "01:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "01:30-02:00",
            startTime: "01:30",
            endTime: "02:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "02:00-02:30",
            startTime: "02:00",
            endTime: "02:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "02:30-03:00",
            startTime: "02:30",
            endTime: "03:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "03:00-03:30",
            startTime: "03:00",
            endTime: "03:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "03:30-04:00",
            startTime: "03:30",
            endTime: "04:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "04:00-04:30",
            startTime: "04:00",
            endTime: "04:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "04:30-05:00",
            startTime: "04:00",
            endTime: "05:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "05:00-05:30",
            startTime: "05:00",
            endTime: "05:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "05:30-06:00",
            startTime: "05:30",
            endTime: "06:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "06:00-06:30",
            startTime: "06:00",
            endTime: "06:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "06:30-07:00",
            startTime: "06:30",
            endTime: "07:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "07:00-07:30",
            startTime: "07:00",
            endTime: "07:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "07:00-08:00",
            startTime: "07:00",
            endTime: "08:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "08:00-08:30",
            startTime: "08:00",
            endTime: "08:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "08:30-09:00",
            startTime: "08:30",
            endTime: "09:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "09:00-09:30",
            startTime: "09:00",
            endTime: "09:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "09:30-10:00",
            startTime: "09:30",
            endTime: "10:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "10:00-10:30",
            startTime: "10:00",
            endTime: "10:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "10:30-11:00",
            startTime: "10:30",
            endTime: "11:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "11:00-11:30",
            startTime: "11:00",
            endTime: "11:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "11:30-12:00",
            startTime: "11:30",
            endTime: "12:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "12:00-12:30",
            startTime: "12:00",
            endTime: "12:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "12:30-13:00",
            startTime: "12:30",
            endTime: "13:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "13:00-13:30",
            startTime: "13:00",
            endTime: "13:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "13:30-14:00",
            startTime: "13:30",
            endTime: "14:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "14:00-14:30",
            startTime: "14:00",
            endTime: "14:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "14:30-15:00",
            startTime: "14:30",
            endTime: "15:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "15:00-15:30",
            startTime: "15:00",
            endTime: "15:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "15:30-16:00",
            startTime: "15:30",
            endTime: "16:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "16:00-16:30",
            startTime: "16:00",
            endTime: "16:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "16:30-17:00",
            startTime: "16:30",
            endTime: "17:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "17:00-17:30",
            startTime: "17:00",
            endTime: "17:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "17:30-18:00",
            startTime: "17:30",
            endTime: "18:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "18:00-18:30",
            startTime: "18:00",
            endTime: "18:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "18:30-19:00",
            startTime: "18:30",
            endTime: "19:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "19:00-19:30",
            startTime: "19:00",
            endTime: "19:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "19:30-20:00",
            startTime: "19:30",
            endTime: "20:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "20:00-20:30",
            startTime: "20:00",
            endTime: "20:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "20:30-21:00",
            startTime: "20:30",
            endTime: "21:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "21:00-21:30",
            startTime: "21:00",
            endTime: "21:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "21:30-22:00",
            startTime: "21:30",
            endTime: "22:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "22:00-22:30",
            startTime: "22:00",
            endTime: "22:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "22:30-23:00",
            startTime: "22:30",
            endTime: "23:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "23:00-23:30",
            startTime: "23:00",
            endTime: "23:30",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
          {
            startTimeToEndTime: "23:30-24:00",
            startTime: "23:30",
            endTime: "24:00",
            chargeVal: "",
            serviceVal: "",
            totalVal: "",
            section: "",
          },
        ],
       
      },
      pageConfig,
      pagination: pageConfig.pagination,
      value2:'',
      isEdit: false,
      detailForm: {},
      selectList: [],
      queryInfo: {
        stationCode: "",
        type: 0,
      },
      listInfo:{},
      fromTime:'',
      toTime:'',
      // 暂存选中得时段
      strategyList: [],
      pickerOptions: {
        //修改el-date-picker的时间
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      searchTime:[],
      formRules: {
        maxAvailablePower: [
          {
            required: true,
            message: "请输入允许补能最大功率",
            trigger: "blur",
          },
        ],
        startEnergySoc: [
          { required: true, message: "请输入开始补能SOC", trigger: "blur" },
        ],
        endEnergySoc: [
          { required: true, message: "请输入结束补能SOC", trigger: "blur" },
        ],
        strategys: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个补能时段",
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted() {
    this.popup.section = "补能";
    this.init();
  },
  methods: {
    // 初始化数据
    init() {
      let _ = this;
      let flag = [];
      _.queryInfo.stationCode = _.$route.query.stationNo;
      _.strategyList = [];
      _.detailForm.timeString = "";
      // 补能数据详情
      _.$H.post(_, _.$A.pilestation.findValleyInfo, _.queryInfo).then((res) => {
        _.detailForm = res.data.data || {};
        if(res.data.data.timeSlotDetailList.length<=0){
            _.popup.customizeList = _.popup.timeSlotDetailList
            _.popup.customizeList.forEach(item=>{
                item.section = ''
            })
        }else{
            _.popup.customizeList = res.data.data.timeSlotDetailList
        }
        
        // let list = res.data.data;
        // if (list) {
        //   list.strategys.forEach((li, n) => {
        //     flag.push(li.startTimeToEndTime);
        //     _.strategyList.push({
        //       startTime: li.startTime,
        //       endTime: li.endTime,
        //       startTimeToEndTime: li.startTimeToEndTime,
        //     });
        //     if (n === 0) {
        //       _.detailForm.timeString = li.startTimeToEndTime;
        //     } else {
        //       _.detailForm.timeString =
        //         _.detailForm.timeString + ", " + li.startTimeToEndTime;
        //     }
        //   });
        //   _.detailForm.strategys = flag;
        // }
      });
      // 列表查询
    
         _.getListData(_.pagination)
    
    
    },
    getListData(pagination, reload = false) {
      let _ = this;
   
      _.listInfo.pageNo = pagination.current-1 ;
      if (reload) {
        this.pagination.current = 1;
        _.listInfo.pageNo = 0;
      }
      _.listInfo.pageSize = pagination.pageSize;
      _.listInfo.corpNo = _.$store.state.corpNo;
      let obj = {
        pageNum:_.listInfo.pageNo,
        pageSize:_.listInfo.pageSize,
        stationCode:_.queryInfo.stationCode,
        fromTime:_.fromTime,
        toTime:_.toTime,
        }
      _.$H
        .post(_, _.$A.pilestation.valleyPage,obj)
        .then((res) => {
         
          _.tableData = res.data.data.content || [];
          _.tableData.forEach(item=>{
           item.flag =  item.firstMsg.slice(1,2)==2?true:false
            // item.firstMsg = item.firstMsg.replace('Accepted', `<span style="color:red;">Accepted</span>`)
            item.firstMsg = item.firstMsg.replace('Rejected', `<span style="color:red;">Rejected</span>`)
          })
        
        _.pagination.total = res.data.data.totalElements || 0;
      
         
        });
    },
      // 获取第一天
      getCurrentMonthFirst(d){
      var date = new Date(d);
      date.setDate(1);
      var month = parseInt(date.getMonth()+1);
      var day = date.getDate();
      if (month < 10) {
          month = '0' + month
      }
      if (day < 10) {
          day = '0' + day
      }
      return date.getFullYear() + '-' + month + '-' + day;
    },
    // 获取最后一天
    getCurrentMonthLast(d){
      var date=new Date(d);
      var currentMonth=date.getMonth();
      var nextMonth=++currentMonth;
      var nextMonthFirstDay=new Date(date.getFullYear(),nextMonth,1);
      var oneDay=1000*60*60*24;
      var lastTime = new Date(nextMonthFirstDay-oneDay);
      var month = parseInt(lastTime.getMonth()+1);
      var day = lastTime.getDate();
      if (month < 10) {
          month = '0' + month
      }
      if (day < 10) {
          day = '0' + day
      }
      return date.getFullYear() + '-' + month + '-' + day;
    },
    handleDateChange(val) {
    console.log(val);
     if(val){
      //  this.dateKey = val ;
       this.fromTime = `${this.getCurrentMonthFirst(val)}`+ ' ' + '00:00:00'
       this.toTime = `${this.getCurrentMonthLast(val)}` + ' ' + '23:59:59'
     }else{
      delete this.fromTime
      delete this.toTime
     }
    console.log(this.fromTime,this.toTime);
    this.getListData(this.pagination)
    },
  
    // 时段选择
    handletariffSelect(val, row, n) {
      let _ = this;

      if (_.popup.section === row.section) {
        _.popup.customizeList[n].section = "";
      } else {
        _.popup.customizeList[n].section = _.popup.section;
      }
      if (val === "") {
        _.popup.customizeList[n].section = _.popup.section;
      }
      // console.log(row.section);
    },
    // 编辑
    handleEdit() {
      let _ = this;
      _.isEdit = true;
    },
    // 处理选择的时间段
    handleSelect(row) {
      let _ = this;
      _.strategyList = [];
      _.selectList.forEach((li) => {
        row.forEach((ll) => {
          if (ll === li.startTimeToEndTime) {
            _.strategyList.push({
              startTime: li.startTime,
              endTime: li.endTime,
              startTimeToEndTime: li.startTimeToEndTime,
            });
          }
        });
      });
      console.log(_.strategyList);
    },
    // 编辑保存
    handleSave(formName) {
      let _ = this;
    
    },
    submitForm(formName) {
        let _ = this;
        
        _.$refs[formName].validate((vaild) => {
        if (vaild) {
          _.$U.showLoading(_)
          let params = {
                    chargeNo: _.queryInfo.chargeNo,
                    maxAvailablePower:_.detailForm.maxAvailablePower,
                    endEnergySoc:_.detailForm.endEnergySoc,
                    startEnergySoc:_.detailForm.startEnergySoc,
                    stationCode: _.queryInfo.stationCode,
                    timeSlotDetailList: _.popup.customizeList
                }
              
                
                _.$H.post(_, _.$A.pilestation.saveValley, params).then(res => {
                    if(res.data.status === 200){
                      setTimeout(() => {
                           _.$U.success('保存成功！')
                        _.init();
                        _.$U.hideLoading(_)
                      }, 3000);
                     
                    }
                })
        }
      });
              
    },
    resetForm() {
      let _ = this
    // _.detailForm.maxAvailablePower = ''
                    
    _.detailForm.endEnergySoc = '';
    _.detailForm.startEnergySoc = '';
    _.popup.customizeList = _.popup.timeSlotDetailList
    },
    Configuration(row){
      let _ = this;
           
           let params = {
              
            pileCode: row.pileCode,
            commandStr: row.firstMsg
           }
         
           
           _.$H.post(_, _.$A.pilestation.reSendCmd, params).then(res => {
               if(res.data.status === 200){
                   _.$U.success('下发成功！')
                   _.init();
               }
           })
    }
  },
};
</script>

<style lang="less" scoped>
.block {
  display: flex;
  justify-content: flex-end;
  align-content: center;
  margin-bottom: 10px;
}
.tool-item {
  width: 100%;
  height: calc((100vh / 4) - 170px);
  line-height: calc((100vh / 4) - 170px);
  text-align: center;
  color: white;
  cursor: pointer;
  margin-bottom: 1px;

  div {
    width: 100%;
    height: 100%;
  }
}
.main-info {
  width: 40%;
  height: 380px;
  display: flex;
  flex-direction: column;
  border: 1px solid #ddd;
  padding: 24px;
  box-sizing: border-box;
  border-radius: 8px;
  font-size: 14px;

  .info-top {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .btn-class {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}
.tariffInfo {
  width: 40%;
  height: 380px;
}
/deep/ .el-button--primary {
  background-color: #b780f3;
  border-color: #b780f3;
}
</style>
